import { Directive, ElementRef, Renderer2, OnInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appAccessibility]',
})
export class AccessibilityDirective implements OnInit {
    constructor(private el: ElementRef, private ngControl: NgControl, private renderer: Renderer2) {}

    ngOnInit(): void {
        let controlName = this.ngControl.name as string;

        // Evitar IDs rotos cuando no existe formControlName
        if (!controlName || controlName.trim() === '') {
            controlName = this.el.nativeElement.id || 'control';
        }

        const helpTextId = `${controlName}Help`;
        const placeholder = this.el.nativeElement.getAttribute('placeholder');
        const label = this.getLabel();
        const title = this.el.nativeElement.getAttribute('title') || label || placeholder;
        let helpTextElement = document.getElementById(helpTextId);
        // 4️⃣ contenedor real de ng-select
        const container: HTMLElement = this.el.nativeElement.querySelector('.ng-select-container');

        // Set aria-required attribute if the control is required
        if (this.ngControl.control?.validator) {
            const validators = this.ngControl.control.validator({} as any);
            if (validators && validators.required) {
                this.renderer.setAttribute(this.el.nativeElement, 'aria-required', 'true');
            }
        }

        // Set aria-label attribute if label is found
        if (label) {
            this.renderer.setAttribute(this.el.nativeElement, 'aria-label', label);
        } else if (container) {
            this.renderer.setAttribute(container, 'aria-label', controlName);
        }

        // Set aria-describedby attribute
        this.renderer.setAttribute(this.el.nativeElement, 'aria-describedby', helpTextId);

        // Set title attribute
        if (title) {
            this.renderer.setAttribute(this.el.nativeElement, 'title', title);
        }

        // Set placeholder attribute
        if (placeholder) {
            this.renderer.setAttribute(this.el.nativeElement, 'placeholder', placeholder);
        }

        // // Create help text element
        // const helpTextElement = this.renderer.createElement('div');
        // this.renderer.setAttribute(helpTextElement, 'id', helpTextId);
        // this.renderer.addClass(helpTextElement, 'form-text');
        // const helpText = this.renderer.createText(placeholder || label || '');
        // this.renderer.appendChild(helpTextElement, helpText);

        // // Insert help text element after the input element
        // const parent = this.el.nativeElement.parentNode;
        // this.renderer.appendChild(parent, helpTextElement);
        if (!helpTextElement) {
            helpTextElement = this.renderer.createElement('div');
            this.renderer.setAttribute(helpTextElement, 'id', helpTextId);
            this.renderer.addClass(helpTextElement, 'visually-hidden');

            const helpText = this.renderer.createText(label || placeholder || '');
            this.renderer.appendChild(helpTextElement, helpText);

            const parent = this.el.nativeElement.parentNode;
            this.renderer.appendChild(parent, helpTextElement);
        }
    }

    private getLabel(): string | null {
        const id = this.el.nativeElement.id;
        if (id) {
            const label = document.querySelector(`label[for="${id}"]`);
            if (label) {
                return label.textContent?.trim() || null;
            }
        }
        return null;
    }
}
